
interface BreadcrumbsProps {
  breadcrumbs: Array<{name: string; slug: string; path: string}>;
}

const Breadcrumbs = ({ breadcrumbs }: BreadcrumbsProps) => {
  return (
    <nav className="flex items-center space-x-2 text-sm" aria-label="Breadcrumb">
      {breadcrumbs.map((crumb, index) => (
        <div key={index} className="flex items-center space-x-2">
          {index > 0 && (
            <i className="ri-arrow-right-s-line text-gray-400"></i>
          )}
          {index === breadcrumbs.length - 1 ? (
            <span className="text-gray-900 font-medium whitespace-nowrap">
              {crumb.name}
            </span>
          ) : (
            <a
              href={crumb.path}
              className="text-gray-500 hover:text-gray-700 transition-colors cursor-pointer whitespace-nowrap flex items-center gap-1"
            >
              {index === 0 && <i className="ri-home-4-line text-xs"></i>}
              {crumb.name}
            </a>
          )}
        </div>
      ))}
    </nav>
  );
};

export default Breadcrumbs;
